// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3HNt_","buttons":"Footer_buttons__17tcR"};